import { createConsumer } from "@rails/actioncable";

const actionCableConsumer = createConsumer();

export default actionCableConsumer;
